// Dynamic mock data loader - Solid Consulting
// Automatically loads the correct language file

import i18n from "../i18n";

// Import all language files
import * as mockEn from "./mock-en";
import * as mockFr from "./mock-fr";
import * as mockAr from "./mock-ar";

const mocksByLang = {
  en: mockEn,
  fr: mockFr,
  ar: mockAr,
};

// Get current language (defaults to 'en')
const getLang = () => (i18n.language || "en").split("-")[0];

// Export all data dynamically based on current language
export const companyInfo = mocksByLang[getLang()].companyInfo;
export const navigation = mocksByLang[getLang()].navigation;
export const services = mocksByLang[getLang()].services;
export const caseStudies = mocksByLang[getLang()].caseStudies;
export const benefits = mocksByLang[getLang()].benefits;
export const workProcess = mocksByLang[getLang()].workProcess;
export const industries = mocksByLang[getLang()].industries;
export const aboutValues = mocksByLang[getLang()].aboutValues;
export const aboutStory = mocksByLang[getLang()].aboutStory;
export const blogPosts = mocksByLang[getLang()].blogPosts;
export const faqs = mocksByLang[getLang()].faqs;
export const contactFormFields = mocksByLang[getLang()].contactFormFields;
